import React from 'react'

import { connect } from "react-redux"

import { authContext, authenticateToken } from '../js/adalAuth'

import ErrorDisplay from '../components/common/ErrorDisplay'
import LoadingDisplay from '../components/common/LoadingDisplay'
import ResponseDisplay from '../components/common/ResponseDisplay'
import Header from './Header'
import Main from './Main'
import Menu from './Menu'

// if the component is accessing the store then we must use withRouter Higher order component to inject in the routing functionality
// without withRouter and with connect routing doesn't work
// withRouter not needed if connect is not used here
import { withRouter } from 'react-router'

import * as appActionCreators from "../actionCreators/app"
import * as authActionCreators from "../actionCreators/auth"

import '../css/app.css'

class App extends React.Component {
  componentDidMount() {
    // only perform adal actions if it is required.
    // this is because the external part of the application won't need this to happen
    if (process.env.REACT_APP_USE_ADAL === 'true') {
      // checks if token exists which happen after the microsoft login process happens and redirects back to here
      if (authenticateToken()) {
        // check that the token found is valid and populates the store with user related details
        this.checkAuthToken()
      }
      else {
        // authenticates user using azure ads login process this will redirect to microsoft's login page if not logged in yet and will redirect back to application when done
        // this will create oauth token to be used in requests
        authContext.login()
      }
    } else {
      this.checkAuthToken()
    }
  }

  checkAuthToken = () => {
    this.props.setLoading(true)
      .then(() => this.props.checkAuthToken())
      .then(() => this.props.setCheckedForUserToken(true))
      .then(() => this.props.setLoading(false))
      .catch(error => {
        this.props.setCheckedForUserToken(true)
        if (error.response && error.response.status === 401) {
          this.props.history.push('/error/401')
          this.props.setLoading(false)
        } else {
          this.props.handleError(error)
            .then(() => this.props.setLoading(false))
        }
      })
  }

  render() {
    return (
      <div className="app-content">
        <ResponseDisplay />
        {/* don't render the main display components until we have checked azure ad so we render things correctly initally */}
        {this.props.auth.hasCheckedForUserToken && <Header />}
        {this.props.auth.hasCheckedForUserToken && <Menu />}
        {this.props.auth.hasCheckedForUserToken && <Main />}
        <ErrorDisplay />
        <LoadingDisplay />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  let { auth } = state
  return { auth }
}

// this is how to combine actions available
const actionCreators = {
  ...authActionCreators,
  ...appActionCreators
}

export default withRouter(connect(mapStateToProps, actionCreators)(App))


// WEBPACK FOOTER //
// ./src/container/App.js